import { inject, Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { DsModalService } from '@design-system/ds-base-modal/services/ds-modal.service';
import { PoMappingModalComponent } from '../component/po-mapping-modal.component';
import { PoMappingInterface, PoMappingModalDataInterface } from '../interfaces/po-mapping-modal-data.interface';
import { PO_MAPPING_MODAL_WIDTH } from '../properties/po-mapping-modal.properties';

@Injectable({
  providedIn: 'root',
})
export class PoMappingModalService {
  private readonly dsModalService = inject(DsModalService);

  /**
   * Opens the PO# mapping modal.
   *
   * @returns the updated PO# mapping, or `null` when the user cancels.
   */
  openDialog$(modalData: PoMappingModalDataInterface): Observable<PoMappingInterface | null> {
    const dialogRef: MatDialogRef<PoMappingModalComponent, PoMappingInterface | null> = this.dsModalService.open<
      PoMappingModalComponent,
      PoMappingModalDataInterface,
      PoMappingInterface | null
    >(PoMappingModalComponent, {
      data: modalData,
      width: PO_MAPPING_MODAL_WIDTH,
      disableClose: true,
    });

    return dialogRef.afterClosed();
  }
}
